var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaverBlockInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_637_1891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 4,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00001 4.69766C7.64434 4.69766 8.16668 4.16831 8.16668 3.51533C8.16668 2.86235 7.64434 2.33301 7.00001 2.33301C6.35568 2.33301 5.83334 2.86235 5.83334 3.51533C5.83334 4.16831 6.35568 4.69766 7.00001 4.69766ZM7.00001 11.956C7.53609 11.956 8.16668 11.5156 8.16668 10.9723V6.38321C8.16668 5.83993 7.53609 5.39951 7.00001 5.39951C6.46393 5.39951 5.83334 5.83993 5.83334 6.38321V10.9723C5.83334 11.5156 6.46393 11.956 7.00001 11.956Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_637_1891)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.83333,
    y: -5.83398,
    width: 25.6667,
    height: 25.6667,
    fill: "#3FAE29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaverBlockInfoIcon);
export default __webpack_public_path__ + "static/media/saver-block-info-icon.b944a6d2e9ffd21e29b655f82f8e64d8.svg";
export { ForwardRef as ReactComponent };